import { CSSProperties, PropsWithChildren } from 'react';
import { useCarouselContext } from '../carousel.context';
import { css, styled } from 'app/pages/request-single-page/components-v4/theme';

type ArrowProps = {
  direction: 'left' | 'right';
  onClick: () => void;
  style?: CSSProperties;
  className?: string;
};

export const Arrow = ({
  direction,
  onClick,
  style,
  className,
  children,
}: PropsWithChildren<ArrowProps>) => {
  const { index, total } = useCarouselContext();

  const disabled = direction === 'left' ? index === 0 : index === total - 1;

  return (
    <StyledButton
      style={{
        [direction === 'left' ? 'left' : 'right']: 0,
        ...style,
      }}
      disabled={disabled}
      className={className}
      onPointerDown={(e) => e.stopPropagation()}
      onClick={(e) => {
        e.stopPropagation();
        onClick();
      }}
    >
      {children}
    </StyledButton>
  );
};

Arrow.displayName = 'Carousel.Arrow';

const StyledButton = styled.button`
  ${({ theme }) => css`
    padding: 0;
    position: absolute;
    z-index: 10;
    top: 50%;
    transform: 'translateY(-50%)';
    background-color: transparent;
    color: #ffffff;
    border: none;
    transition-duration: 200ms;
    cursor: pointer;

    &:disabled {
      color: ${theme.colors.gray[400]};
      cursor: not-allowed;
    }
  `}
`;
